import React from "react";
import "../style/AboutUs.css";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import director1 from "../assets/directors/mahendra.png";
import director2 from "../assets/directors/manish.png";
import director3 from "../assets/directors/manju.png";
// ❌ CloudImage removed for founder only
// import CloudImage from '../components/CloudImage';

const CDN_BASE = "https://cdn.greateastern.in/GETCO/";

// ✅ Directors list stays same
const directors = [
  {
    name: "Mahendra Kumar Baid",
    image: director1,
    quote: "Leading with integrity and wisdom.",
  },
  {
    name: "Manish Kumar Baid",
    image: director2,
    quote: "Driving innovation in every decision.",
  },
  {
    name: "Manju Baid",
    image: director3,
    quote: "Balancing tradition with modern values.",
  },
];

const AboutUs = () => {
  return (
    <div className="aboutus-container">
      <h2 className="section-title">About Great Eastern Trading Co.</h2>
      <p>
        Great Eastern Trading Co. is a unit of <strong>M/s Great Eastern Hire Purchase Pvt. Ltd.</strong> (CIN-U65921WB1998PTC086421). It is a private limited company having its registered office at 20, Old Court House Street, Kolkata WB 700001.
      </p>
      <p>
        We are engaged in the business of trading electronics, home appliances, and other consumer durables like Televisions, Refrigerators, Washing Machines, Air Conditioners, Audio Systems, Mobiles, and Digital & Movie Cameras. We deal with products from every reputed Indian and international manufacturer.
      </p>

      <h2 className="section-title">Founder Tribute</h2>
      <div className="founder-tribute">

        {/* ⭐ Replaced CloudImage with direct CDN image */}
        <img
          src={`${CDN_BASE}founder_yyr8in.jpg`}   // ← change extension if needed
          width={150}
          height={200}
          alt="Our Founder"
          className="founder-image"
        />

        <div className="founder-text">
          <p>
            <strong>Late Shri Punam Chand Baid</strong> began his journey in 1976 with a single store in Dalhousie, West Bengal, selling electronic appliances. The showroom was located in the heart of the business hub of Dalhousie.
          </p>
          <p>
            With years of dedication by Mr. Punam Chand Baid, Mr. Mahendra Kumar Baid, and Mr. Manish Kumar Baid, the company has grown through unmatched pricing, product variety, and customer service. Today, we have <strong>100+ multi-brand electronic retail outlets</strong> across 6 states.
          </p>
          <p>
            We’ve received awards year after year for being the <strong>"Best Dealer in East"</strong> from top brands like Sony, Hitachi, Whirlpool, and LG.
          </p>
        </div>
      </div>

      <h2 className="section-title">Board of Directors</h2>

      {/* ==== Desktop Carousel ==== */}
      <div className="carousel-desktop">
        <Carousel
          showThumbs={false}
          showStatus={false}
          infiniteLoop
          autoPlay
          interval={3000}
          stopOnHover
          showIndicators={true}
          renderArrowPrev={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button className="carousel-arroww left" onClick={onClickHandler}>
                ‹
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext) =>
            hasNext && (
              <button className="carousel-arroww right" onClick={onClickHandler}>
                ›
              </button>
            )
          }
        >
          {directors.map((dir, idx) => (
            <div className="director-slide" key={idx}>
              <img src={dir.image} alt={dir.name} className="director-image" />
              <p className="director-name">{dir.name}</p>
              <p className="director-quote">“{dir.quote}”</p>
            </div>
          ))}
        </Carousel>
      </div>

      {/* ==== Mobile Carousel ==== */}
      <div className="carousel-mobile">
        <Carousel
          showThumbs={false}
          showStatus={false}
          infiniteLoop
          autoPlay
          interval={3000}
          stopOnHover
          showIndicators={true}
          renderArrowPrev={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button className="carousel-arroww left" onClick={onClickHandler}>
                ‹
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext) =>
            hasNext && (
              <button className="carousel-arroww right" onClick={onClickHandler}>
                ›
              </button>
            )
          }
        >
          {directors.map((dir, idx) => (
            <div className="director-slide-mobile" key={idx}>
              <img src={dir.image} alt={dir.name} className="director-image-mobile" />
              <p className="director-name">{dir.name}</p>
              <p className="director-quote">“{dir.quote}”</p>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default AboutUs;
